export default "__VITE_ASSET__J34Ge6LW__"